import { render, staticRenderFns } from "./AddBranchModal.vue?vue&type=template&id=3012b63a&scoped=true&"
import script from "./AddBranchModal.vue?vue&type=script&lang=ts&"
export * from "./AddBranchModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddBranchModal.vue?vue&type=style&index=0&id=3012b63a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012b63a",
  null
  
)

export default component.exports